export const ERROR = {
  GET_DOCK_UNAVAIL: {
    message: 'Echec lors de la récupération des contraintes de quais',
    isPopup: false,
    isDefault: true,
  },
  GET_GRADE_UNAVAIL: {
    message: 'Echec lors de la récupération des contraintes de grades',
    isPopup: false,
    isDefault: true,
  },
  GET_ORDER_SUMMARY: {
    message: 'Echec lors de la récupération des commandes',
    isPopup: false,
    isDefault: true,
  },
  GET_PRODUCT_SUMMARY: {
    message: 'Echec lors de la récupération du détail de la commandes',
    isPopup: false,
    isDefault: true,
  },
  GET_PRODUCT_DETAILS: {
    message: 'Echec lors de la récupération du détail du produit',
    isPopup: false,
    isDefault: true,
  },
  GET_MACRO_SLOTS: {
    message: 'Echec lors de la récupération des macro slots',
    isPopup: false,
    isDefault: true,
  },
  GET_TONNAGE_SUMMARY: {
    message: 'Echec lors de la récupération du tonnage',
    isPopup: false,
    isDefault: true,
  },
  GET_ORDER_NUMBER_SUMMARY: {
    message: 'Echec lors de la récupération du nombre de commandes',
    isPopup: false,
    isDefault: true,
  },
  GET_PRODUCTS_BY_MACRO_SLOTS: {
    message: 'Echec lors de la récupération des produits par macro slots',
    isPopup: false,
    isDefault: true,
  },
  GET_PLANNING_APPOINTMENTS: {
    message: 'Echec lors de la récupération des rendez-vous',
    isPopup: false,
    isDefault: true,
  },
  GET_PLANNING_STATICS: {
    message: 'Echec lors de la récupération des données statiques du planning',
    isPopup: false,
    isDefault: true,
  },
  GET_EXTENSIONS: {
    message: 'Echec lors de la récupération des extensions',
    isPopup: false,
    isDefault: true,
  },
  SAVE_UNAVAIL: [
    {
      message:
        'Une erreur s\'est produite lors de la modification des indisponibilités',
      isPopup: false,
      status: 0,
      isDefault: true,
    },
    {
      message: undefined,
      isPopup: true,
      status: 409,
    },
  ],
  DELETE_EXTENSION: [
    {
      message:
        'Une erreur s\'est produite lors de la suppression des horaires d\'extensions',
      isPopup: false,
      status: 0,
      isDefault: true,
    }
  ],
};

export const SUCCESS = {
  SAVE_UNAVAIL: 'Toutes les modifications ont bien été prises en compte',
  SAVE_EXTENSION: 'Les horaires d\'extensions ont bien été modifiés',
  DELETE_EXTENSION: 'Les horaires d\'extensions ont bien été supprimés',
};

export interface ErrorMessagesConfiguration {
  message?: string;
  status?: number;
  isPopup?: boolean;
  isDefault?: boolean;
}
